var React = require('react');

function NpClose (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"65.0537","width":"6","height":"92","rx":"3","transform":"rotate(45 65.0537 0)","fill":"black","key":0}),React.createElement("rect",{"x":"0.0537109","y":"4.24219","width":"6","height":"92","rx":"3","transform":"rotate(-45 0.0537109 4.24219)","fill":"black","key":1})]);
}

NpClose.defaultProps = {"width":"70","height":"70","viewBox":"0 0 70 70"};

module.exports = NpClose;

NpClose.default = NpClose;
